import { Grid, Typography } from "@mui/material";

export const EmptyRecommendations = () => {
	return (
		<Grid container justifyContent={"center"}>
			<Grid item>
				<Typography variant="body1">No recommendations found</Typography>
			</Grid>
		</Grid>
	);
};
